import React from "react";
import Main from "../../components/main";
import Box from "../../components/box";
import A from "../../components/a";
import P from "../../components/p";
import "./styles.css";

const TermsAndConditions = () => (
  <div className="terms">
    <Main>
      <Box>
        <h1>Terms And Conditions Of Use</h1>
        <h2>Intellectual Property Rights</h2>
        <P>
          Ghast owns all the intellectual property rights and materials
          contained in this Website. You are granted limited license only for
          purposes of viewing the material contained on this Website.
        </P>
        <h2>Copyright</h2>
        <P>
          All content included on this site, such as text, graphics, logos,
          button icons, images, audio clips, digital downloads, data
          compilations, and software, is the property of Ghast or its content
          suppliers and protected by international copyright laws. The
          compilation of all content on this site is the exclusive property of
          Ghast, with copyright authorship for this collection by Ghast, and
          protected by international copyright laws.
        </P>
        <h2>Your Membership Account</h2>
        <P>
          If you use this product, you are responsible for maintaining the
          confidentiality of your account and password and for restricting
          access to your computer, and you agree to accept responsibility for
          all activities that occur under your account or password. If you are
          under 18, you may use our product only with involvement of a parent or
          guardian. Ghast and its associates reserve the right to refuse
          service, terminate accounts, remove or edit content, or cancel orders
          in their sole discretion.
        </P>
        <h2>Refund Policy</h2>
        <P>
          You have the right to a full refund within 7 days of purchase, after
          that period you are not entitled to any refund.
        </P>
        <h2>Additional Terms and Conditions; EULAs</h2>
        <P>
          When you use G2A Pay services provided by{" "}
          <A href="g2a.com" className="redlink">
            G2A.COM
          </A>{" "}
          Limited (hereinafter referred to as the ""G2A Pay services provider"")
          to make a purchase on our website, responsibility over your purchase
          will first be transferred to{" "}
          <A href="g2a.com" className="redlink">
            G2A.COM
          </A>{" "}
          Limited before it is delivered to you.{" "}
          <A href="g2a.com" className="redlink">
            G2A.COM
          </A>{" "}
          is becoming Merchant of Record over your purchase. G2A Pay services
          provider assumes primary responsibility, with our assistance, for
          payment and payment related customer support. The terms between G2A
          Pay services provider and customers who utilize services of G2A Pay
          are governed by separate agreements which can be found under the link{" "}
          <A href="g2a.com" className="redlink">
            https://pay.g2a.com/terms-and-conditions
          </A>{" "}
          and are not subject to the Terms on this website. In order to proceed
          the payment transaction, you temporary entrusts the{" "}
          <A href="g2a.com" className="redlink">
            G2A.COM
          </A>{" "}
          with subject of the transaction, and{" "}
          <A href="g2a.com" className="redlink">
            G2A.COM
          </A>{" "}
          takes responsibility for the product and for the transaction
          processing. With respect to customers making purchases through G2A Pay
          services provider checkout, (i) the Privacy Policy of G2A Pay services
          provider shall apply to all payments and should be reviewed before
          making any purchase, and (ii) the G2A Pay services provider Refund
          Policy shall apply to all payments unless notice is expressly provided
          by the relevant supplier to buyers in advance. In addition the
          purchase of certain products may also require shoppers to agree to one
          or more End-User License Agreements (or ""EULAs"") that may include
          additional terms set by the product supplier rather than by Us or G2A
          Pay services provider. You will be bound by any EULA that you agree
          to. You are responsible for any fees, taxes or other costs associated
          with the purchase and delivery of your items resulting from charges
          imposed by your relationship with payment services providers or the
          duties and taxes imposed by your local customs officials or other
          regulatory body. For customer service inquiries or disputes, You may
          contact us by email at{" "}
          <A href="mailto:support@ghast.io" className="redlink">
            support@ghast.io
          </A>
          . Questions related to payments made through G2A Pay services provider
          payment should be addressed to{" "}
          <A href="mailto:support@g2a.com" className="redlink">
            support@g2a.com
          </A>
          . Where possible, we will work with you and/or any user selling on our
          website, to resolve any disputes arising from your purchase.
        </P>
      </Box>
    </Main>
  </div>
);

export default TermsAndConditions;



/** WEBPACK FOOTER **
 ** ./src/views/pages/termsAndConditions/index.js
 **/